<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap2"><i>Rain Moving In</i></h1>
<p class="poem1" style="margin-top:30px;">The blackboard is erased in the attic</p>
<p class="poem1">And the wind turns up the light of the stars,</p>
<p class="poem1">Sinewy now. Someone will find out, someone will know.</p>
<p class="poem1">And if somewhere on this great planet</p>
<p class="poem1">The truth is discovered, a patch of it, dried, glazed by the sun,</p>
<p class="poem1">It will just hang on, in its own infamy, humility. No one</p>
<p class="poem1">Will be better for it, but things can’t get any worse.</p>
<p class="poem1">Just keep playing, mastering as you do the step</p>
<p class="poem1">Into disorder this one meant. Don’t you see</p>
<p class="poem1">It’s all we can do? Meanwhile, great fires</p>
<p class="poem1">Arise, as of haystacks aflame. The dial has been set</p>
<p class="poem1">And that’s ominous, but all your graciousness in living</p>
<p class="poem1">Conspires with it, now that this is our home:</p>
<p class="poem1">A place to be from, and have people ask about.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6chap2.vue?d7cd0672